import api from "../axios_service.js";

// Produtos
export async function fetchComprasItems(compra_id) {
  const response = await api.get(`/compras-items?compra_id=${compra_id}`);
  return response.data.result;
}
